<div
  class="tile add-service-tile animate__animated card ziro-card"
  data-automation="add-service-tile"
  [ngClass]="{
    muted: !isEnabled(),
    'tile-warning animate__infinite animate__pulse': isAdding() && !isInProgress(),
    'tile-default': !isAdding() && !isInProgress(),
    'tile-in-progress': isInProgress(),
    'animate__flipInY animate__fast': isDeleted() && !isAdding(),
  }"
  [ngbTooltip]="tooltip() | translate"
  (click)="onTileClicked()"
>
  <div class="text-center">
    <p [ngClass]="'svg-icon-class'">
      <i [attr.data-automation]="icon()" [ngClass]="icon()" [ngStyle]="{ 'font-size': '40px' }"></i>
    </p>

    <div class="user-detail-tile-title mb-1">
      <span data-automation="service-tile-name">{{ serviceName() | translate }}</span>
    </div>

    @if (!isAdding() && !isInProgress() && isEnabled()) {
      <i class="fa fa-plus-circle fa-2x"></i>
    }

    @if (isAdding() && !isInProgress()) {
      <i class="fa-2x tile-add-spinner" [ngClass]="ziroIcons.SAVING"></i>
    }

    @if (isInProgress()) {
      <div class="mx-auto d-flex align-items-center alert-inline alert alert-warning animate__animated animate__fadeIn">
        <i class="fa-1x tile-add-spinner me-2" [ngClass]="ziroIcons.SAVING"></i>
        <div class="d-inline-flex align-items-center" data-automation="add-service-tile-in-progress">
          {{ isInProgressBadgeText() | translate }}
        </div>
      </div>
    }
  </div>
</div>
